module.exports = __webpack_public_path__ + "img/logo-threatcoach-light.7762c5b0.svg";